import { Component, OnInit} from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-detalleproduct',
  templateUrl: './detalleproduct.component.html',
  styleUrls: ['./detalleproduct.component.scss'],
})

export class DetalleproductComponent implements OnInit {
  sliderOpts= {
    zoom:{maxRatio: 2}
  };
  constructor(public navParams:NavParams, public poper: PopoverController) {
    this.producto = this.navParams.get('producto');
   }

  ngOnInit() {}
producto;

async cerarPopOver(){  
  this.poper.dismiss(); 
}

}
